export default {
	contact_information_action_email: 'Write email',
	contact_information_action_open_record: 'Open record',
	contact_information_action_phone: 'Call',
	contact_information_close: 'Close',
	contact_information_column_action: 'Action',
	contact_information_column_display_text: 'Name',
	contact_information_column_display_value: 'Contact',
	contact_information_column_record: 'Record',
	contact_information_dialog_title: 'Contact',
	contact_information_empty_initial_caption: 'Enter a search term to find contact details.',
	contact_information_empty_initial_title: 'No search yet',
	contact_information_empty_search_caption: 'Change the search term or filter.',
	contact_information_empty_search_title: 'No contact details found',
	contact_information_filter_all: 'All',
	contact_information_filter_email: 'Email',
	contact_information_filter_email_addresses: 'Email addresses',
	contact_information_filter_email_aria_label: 'Toggle email filter',
	contact_information_filter_email_tooltip: 'Filter email contacts',
	contact_information_filter_phone: 'Phone',
	contact_information_filter_phone_aria_label: 'Toggle phone filter',
	contact_information_filter_phone_numbers: 'Phone numbers',
	contact_information_filter_phone_tooltip: 'Filter phone contacts',
	contact_information_filter_type_aria_label: 'Filter contact type',
	contact_information_launcher_tooltip: 'Contact',
	contact_information_search_label: 'Search contact details',
	contact_information_search_pending_caption: 'Contact details are being loaded.',
	contact_information_search_pending_title: 'Search in progress',
};
